import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { ProductosService } from 'src/app/services/productos.service';
import { ProveedoresService } from 'src/app/services/proveedores.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-insumos',
  templateUrl: './insumos.component.html',
  styleUrls: ['./insumos.component.scss']
})
export class InsumosComponent implements OnInit {
  environment = environment.BASE_URL

  productos;
  categorias;

  formulario;
  data;
  datosProducto;
  formularioEdit;
  filtro;
  imagenActual;
  insumoid;
  unidades:any;
  
  respuestaGet:any;
  respuestaAgregar:any;
  respuestaEditar:any;
  respuestaUpdate:any;

  selectedArchivo:any;

  proveedores:any;

  precio = 0;
  activo = 1;

  constructor(private modalService:NgbModal, private _get:ProductosService, private iziToast:Ng2IzitoastService,
    private _proveeedor:ProveedoresService) { }

  ngOnInit(): void {
    this.formulario = {
      'nombre':'',
      'clasificacion_gasto':'',
      'unidad_medida':'',
      'precio':'',
      'descripcion':'',
      'proveedor':'',
      'factor_conversion':'',
      'unidad_medida_proveedor':'',
      'marca': '',
    }

    this.formularioEdit = {
      'nombre':'',
      'descripcion':'',
      'precio':'',
      'unidad_medida':'',
      'clasificacion_gasto':'',
      'proveedor':'',
      'factor_conversion':'',
      'unidad_medida_proveedor':'',
      'marca': '',
    }

    this.filtro = {
      'activo':1,
      'categoria':'',
      'proveedor':'',
    }
    
    this.getInsumos();
    this.getCategoriasInsumos();
    this.getUnidadesMedida();
    this.getProveedores();
  }
  getInsumos(){
    this._get.getInsumos().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.productos = this.respuestaGet.content;
        }else {
          this.iziToast.show(
            {
                title: 'Hubo un problema al cargar los productos',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
        }
      }, error => console.error(error))
  }

  getCategoriasInsumos(){
    this._get.getCategoriasInsumos().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.categorias = this.respuestaGet.content;
        }else {
          this.iziToast.show(
            {
                title: 'Hubo un problema al cargar los productos',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
        }
      }, error => console.error(error))
  }

  getUnidadesMedida(){
    this._get.getUnidadesMedida().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.unidades = this.respuestaGet.content;
        }else {
          this.iziToast.show(
            {
                title: 'Hubo un problema al cargar los productos',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
        }
      }, error => console.error(error))
  }

  getProveedores(){
    this._proveeedor.getProveedores().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.proveedores = this.respuestaGet.content;
        }else {
          this.iziToast.show(
            {
                title: 'Hubo un problema al cargar los productos',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
        }
      }, error => console.error(error))
  }

  getInsumosFilter(){
    if(this.filtro.activo == 1){
      this.activo = 1
    }else{
      this.activo = 0
    }
    this.data = {
      'activo': this.filtro.activo,
      'categoria': this.filtro.categoria,
      'proveedor': this.filtro.proveedor,
    }

    this._get.getInsumosFilter(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.productos = this.respuestaGet.content;
        }else {
          this.iziToast.show(
            {
                title: 'Hubo un problema al cargar los productos',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
        }
      }, error => console.error(error))
  }

  fileChange(event: any): void{
    this.selectedArchivo = event.target.files;
    this.formulario.archivo = this.selectedArchivo?.item(0);
    // || this.invoice.ticket.type.toString() !== 'image/jpeg'
  }

  fileChangeEdit(event: any): void{
    this.selectedArchivo = event.target.files;
    this.formularioEdit.archivo = this.selectedArchivo?.item(0);
    // || this.invoice.ticket.type.toString() !== 'image/jpeg'
  }


  agregarInsumo(){
    const formData = new FormData();
    formData.append('nombre', this.formulario.nombre);
    formData.append('precio_inicial', this.formulario.precio);
    formData.append('contenido', this.formulario.contenido);
    formData.append('marca', this.formulario.marca);
    formData.append('factor_conversion', this.formulario.factor_conversion);
    formData.append('unidad_medida_proveedor', this.formulario.unidad_medida_proveedor);
    formData.append('unidad_medida', this.formulario.unidad_medida);
    formData.append('clasificacion_gasto', this.formulario.clasificacion_gasto);
    formData.append('proveedor_preferido', this.formulario.proveedor);
    if (this.formulario.archivo){ 
      formData.append('imagen', this.formulario.archivo);
    }

    this._get.agregarInsumo(formData).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado el producto correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.monto = '';
          this.formulario.nombre = '';
          this.formulario.descripcion = '';
          this.dismissAll();
          this.getInsumosFilter();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  editarInsumo(insumo){
    this.data = {
      'insumo':insumo,
    }
    this._get.editarInsumo(this.data).subscribe(
      data => {
        this.respuestaEditar = data;
        if(this.respuestaEditar.success){
          this.datosProducto = this.respuestaEditar.content;
          this.formularioEdit.nombre = this.datosProducto.nombre;
          this.formularioEdit.precio = this.datosProducto.precio;
          this.formularioEdit.marca = this.datosProducto.marca;
          this.formularioEdit.contenido = this.datosProducto.contenido;
          this.formularioEdit.clasificacion_gasto = this.datosProducto.categoriaId;
          this.formularioEdit.proveedor = this.datosProducto.proveedor;
          this.formularioEdit.unidad_medida = this.datosProducto.unidad_medidaId;
          this.formularioEdit.unidad_medida_proveedor = this.datosProducto.unidad_medida_proveedor;
          this.formularioEdit.factor_conversion = this.datosProducto.factor_conversion;
          this.imagenActual = this.datosProducto.imagen;
          this.insumoid = insumo;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  updateInsumo(insumo){
    const formData = new FormData();
    formData.append('nombre', this.formularioEdit.nombre);
    formData.append('precio_inicial', this.formularioEdit.precio);
    formData.append('contenido', this.formularioEdit.contenido);
    formData.append('marca', this.formularioEdit.marca);
    formData.append('clasificacion_gasto', this.formularioEdit.clasificacion_gasto);
    formData.append('proveedor', this.formularioEdit.proveedor);
    formData.append('unidad_medida', this.formularioEdit.unidad_medida);
    formData.append('unidad_medida_proveedor', this.formularioEdit.unidad_medida_proveedor);
    formData.append('factor_conversion', this.formularioEdit.factor_conversion);
    formData.append('insumo', insumo);
    if (this.formularioEdit.archivo){ 
      formData.append('imagen', this.formularioEdit.archivo);
    }


    this._get.updateInsumo(formData).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado el insumo correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.getInsumosFilter();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  activarInsumo(productoId){

  }

  desactivarInsumo(productoId){

  }

  openModal(modal:any) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
